// extracted by mini-css-extract-plugin
export default {"button":"ProductAddDropButton_button__Pa2fJ","button_drop":"ProductAddDropButton_button_drop__kosB3"};